import { SYSTEM_NOTIFICATIONS } from "./notificationConstants.js";

// setting initial locale to en-en so that copySelector throws correct errors even
// if no locale is set before the first loadLocaleCopy action is dispatched
export const INITIAL = {
  isError: false,
  isReady: false,
  isFetching: false,
  data: undefined
};

export function systemNotificationReducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case SYSTEM_NOTIFICATIONS.REQUEST:
      return {
        ...state,
        isError: false,
        isFetching: true,
        isReady: false
      };

    case SYSTEM_NOTIFICATIONS.RECEIVE:
      return {
        ...state,
        isFetching: false,
        isReady: true,
        data: action.payload
      };

    case SYSTEM_NOTIFICATIONS.FAILURE:
      return {
        ...state,
        isError: true,
        isFetching: false,
        isReady: false
      };

    default:
      return state;
  }
}
